export const Languages = [
    {//esp
        "alertLoadingMessage": "Cargando...",
        "termsConditionsText": "Las imágenes publicadas, planos, renders y demás piezas publicitarias son representaciones digitales del diseño y junto con el apartamento modelo exhibido en la sala de ventas, pueden variar en su percepción y construcción final y están sujetos a modificación y cambios sin previo aviso o consulta, por lo tanto, no constituyen oferta por parte del promotor y/o constructor. Las áreas comunes amobladas corresponden a imágenes de referencia, que no hacen parte de la oferta comercial, las mismas están sujetas a modificación y cambios discrecionales sin previo aviso o consulta por parte del constructor, conservando las características de calidad, seguridad e idoneidad.",
        "introButtonContinue": "Ingresar",
        "buildingPointAlertButtonContinue": "Ingresar",
        "aptoPointAlertButtonContinue": "Ingresar",
        "buildingMenuFloorSubTilte": "Plantas",
        "aptoStatusAvailable": "Disponible",
        "aptoStatusUnavailable": "Vendido",
        "aptoStatusReserve": "Reservado",
        "genericSpecsTitle": "Especificaciones",
        "genericAreaTitle": "Área Total",
        "genericRoomTitle": "Habitación",
        "genericRoomsTitle": "Habitaciones",
        "genericBathroomTitle": "Baño",
        "genericBathroomsTitle": "Baños",
        "genericAreaBalconyTitle": "Balcón",
        "genericNoAreaBalconyTitle": "Sin Balcón",
        "genericCostSimulatorButton": "Simulador de costos",
        "genericDownloadBrochureButton": "Descargar Brochure",
        "contactTitle": "Contacto",
        "nearmeTransportTitle": "Transporte",
        "nearmeMallTitle": "Comercio",
        "nearmeEducationTitle": "Educación",
        "nearmeHealthTitle": "Salud",
        "costSimulatorTitle": "Simulador compra de vivienda",
        "costSimulatorInfoBuildingName": "Torre",
        "costSimulatorInfoFloorName": "Piso",
        "costSimulatorInfoAptoName": "Apartamento",
        "costSimulatorAptoTypeListItem": "Apto",
        "costSimulatorAptoCostTile": "Valor del inmueble",
        "costSimulatorSeparationValueText": "Valor de separación",
        "costSimulatorMinDownPaymentText": "Cuota inicial mínima 30%",
        "costSimulatorDownPaymentText": "Cuota inicial",
        "costSimulatorCreditUVRButton": "Crédito hipotecatio (UVR)",
        "costSimulatorCreditPesosButton": "Crédito hipotecatio (Pesos)",
        "costSimulatorHasSubsidyChecbox": "¿Vas a utilizar subsidio de vivienda?",
        "costSimulatorTermText": "Plazo de pago %value% meses",
        "costSimulatorCreditValueText": "Valor del crédito",
        "costSimulatorCreditTermsText": "**Cuota calculada con plan de amortización en pesos y tasa M.V del 13.48%",
        "costSimulatorSelectCreditTermTitle": "Selecciona el plazo del crédito",
        "costSimulatorYearText": "años",
        "costSimulatorMonthlyCreditValueText": "Valor mensual del crédito",
        "costSimulatorUVRText": "UVR",
        "costSimulatorCurrencyText": "Pesos",
        "costSimulatorWhatsAppButton": "Contactar",
        "searchAlertTitle": "Filtros de busqueda",
        "searchAlertBedroomsText": "Habitaciones",
        "searchAlertBathroomsText": "Baños",
        "searchAlertBalconyText": "Balcón",
        "searchAlertFloorText": "Piso",
        "searchAlertAreaText": "Área",
        "searchAlertTypologyText": "Tipología",
        "searchAlertResultText": "Resultado",
        "searchAlertResultPriceText": "Precio",
        "searchAlertResultStatusText": "Estado",
        "searchAlertResultNameText": "Apto",
        "searchAlertResultBuildingText": "T",
    },
    {//eng
        "introButtonContinue": "Continue",
        "buildingPointAlertButtonContinue": "Enter",
    }
];